import { DrawerModel } from '@_types/types';
import { getModifiers } from '@helpers/functions';
import Button from '@atoms/buttons/Button';
import { ReactNode } from 'react';

type Props = {
  children?: ReactNode;
} & DrawerModel;

const Drawer = (model: Props) => {
  const styleModifier = getModifiers(model, 'kf-m-drawer');
  const { children, closeIconButton, mainButton, subButton } = model;

  return (
    <div className={styleModifier}>
      <div className="kf-m-drawer__overlay" />
      <div className="kf-m-drawer__main">
        <div className="kf-m-drawer__header">
          <div className="kf-m-drawer__header__top">
            {closeIconButton && (
              <Button {...closeIconButton} className="kf-m-drawer__header__close" dataSet={{ 'aria-label': 'Drawer Close Button' }} />
            )}
          </div>
        </div>

        <div className="kf-m-drawer__content">{children}</div>

        <div className="kf-m-drawer__footer">
          {mainButton && <Button {...mainButton} />}
          {subButton && <Button {...subButton} />}
        </div>
      </div>
    </div>
  );
};

export default Drawer;
